export const EXTERNAL = {
  juvo: 'https://juvo.healthgeek.org.ml',
  dental: 'https://dental.healthgeek.org.ml',
  email: 'mailto:contact@healthgeek.org.ml',
} as const;

export function isModifiedClick(event: MouseEvent) {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
}
